const validate = (values) => {
    const errors = {};
  
    if (!values.programName) {
      errors.programName = 'Please enter program name';
    }
    return errors;
  };
  export default validate;
  


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/program/validate.js